import React from 'react';
import { motion } from 'framer-motion';
import { TartaEmblem } from './TartaEmblem';
import { useLanguage } from '../context/LanguageContext';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  return <section className="py-40 lg:py-56 bg-texture-espresso text-cream relative overflow-hidden border-t border-cream/5" data-id="element-36">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 1.2
    }} className="relative max-w-[1200px] mx-auto px-8 lg:px-14 text-center flex flex-col items-center" data-id="element-37">
        <TartaEmblem size={88} variant="dark" withTagline className="ring-1 ring-cream/20 mb-12" data-id="element-38" />

        <div className="flex items-center justify-center gap-4 text-[10px] tracking-[0.5em] uppercase text-caramel mb-10" data-id="element-39">
          <span className="w-12 h-px bg-caramel/40" data-id="element-40" />
          <span className="font-serif italic normal-case tracking-[0.1em] text-[13px]" data-id="element-41">
            {t.finalCTA.edition}
          </span>
          <span className="w-12 h-px bg-caramel/40" data-id="element-42" />
        </div>

        <h2 className="font-serif font-light leading-[0.9] tracking-[-0.035em]" style={{
        fontSize: 'clamp(64px, 11vw, 180px)'
      }} data-id="element-43">
          {t.finalCTA.title1}
          <br data-id="element-44" />
          <span className="italic font-extralight" data-id="element-45">{t.finalCTA.title2}</span>
          <br data-id="element-46" />
          {t.finalCTA.title3}
          <span className="text-caramel" data-id="element-47">.</span>
        </h2>

        <p className="mt-16 font-serif italic text-cream/65 leading-[1.6] text-xl lg:text-2xl max-w-xl mx-auto" data-id="element-48">
          {t.finalCTA.copy1}
          <br data-id="element-49" />
          {t.finalCTA.copy2}
        </p>

        <a href="#waitlist" className="group mt-16 inline-flex items-center gap-6 text-cream" data-id="element-50">
          <span className="w-12 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-20 transition-all duration-500" data-id="element-51" />
          <span className="font-serif italic text-[15px] tracking-[0.05em]" data-id="element-52">
            {t.finalCTA.cta}
          </span>
          <span className="w-12 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-20 transition-all duration-500" data-id="element-53" />
        </a>
      </motion.div>
    </section>;
}